import * as api from '../api'

// Action creator
export const createQuizz = (quizz, match) => async (dispatch, getState) => {
    try {

        const newQuizz = quizz
        newQuizz.creation = Date.now()
        newQuizz.idMatch = match.idMatch ? match.idMatch : match.idActu
        if(newQuizz.timer === undefined)
            newQuizz.timer = !match.timer ? 0 : match.timer === 0 ? (Math.floor(match.timer/60))*60 : (Math.floor((match.timer + 60)/60))*60
        if(newQuizz.period === undefined)
            newQuizz.period = match.period ? match.period : 0

        const { data } = await api.createQuizz(newQuizz)

        console.log('created quizz', data);

        return data;

        //dispatch( { type : CREATE_NOTATION, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

/*
export const addNote = (id, note) => async (dispatch, getState) => {
    try {
        const { data } = await api.addNote(id, {note : note})

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error.message)
    }
}*/

export const updateQuizz = (quizzDetail, id) => async (dispatch, getState) => {
    try {
        const { data } = await api.updateQuizz(id, quizzDetail)

        console.log('updated quizz', data);

        return data;

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const deleteQuizz = (id) => async (dispatch) => {
    try {
        await api.deleteQuizz(id)

        //dispatch({ type : DELETE_NOTATION, payload: id})
    }catch(error){
        console.log(error)
        throw error;
    }
}